// extracted by mini-css-extract-plugin
module.exports = {"main":"nav_main__4ryXs"};